import { useLayoutEffect, useRef } from 'react';

export function useCallbackRef(callback) {
    const callbackRef = useRef(callback);

    useLayoutEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    return callbackRef;
}